import BallPulse from '@tock/shared/components/BallPulse';
import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

class TransitionLoading extends PureBaseComponent {
  render() {
    return (
      <div className="TransitionLoading">
        <BallPulse modifierClassName="TransitionLoading-transition" />
      </div>
    );
  }
}

export default TransitionLoading;
